// removed by extract-text-webpack-plugin
module.exports = {"realtor":"_3fmgXE79TjbBMhQZrf5FaQ"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Realtor/Realtor.scss
// module id = 1720
// module chunks = 0